/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-04 18:48:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2020-11-20 17:21:00
 * @Description: 维护界面
 * @FilePath: /src/components/maintain/index.js
 */
import maintain from './index.vue';
import Vue from 'vue';

let el = null;

const _maintain = {
    open({
        type = 0
    } = {}) {
        if (el) {
            return;
        }
        let model = Vue.extend(maintain);
        let mVm = new model();
        el = mVm.$mount().$el;
        document.body.appendChild(el);
    },
    close() {
        if (!el) {
            return;
        }
        document.body.removeChild(el);
        el = null;
    },
};

export default _maintain;
